export default "__VITE_ASSET__cc95c29d__"